import { render, staticRenderFns } from "./authorDetail.vue?vue&type=template&id=5217e7c9&scoped=true"
import script from "./authorDetail.vue?vue&type=script&lang=js"
export * from "./authorDetail.vue?vue&type=script&lang=js"
import style0 from "./authorDetail.vue?vue&type=style&index=0&id=5217e7c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217e7c9",
  null
  
)

export default component.exports